import React, { useEffect, useState, useRef, useCallback } from "react";
import { useGlobalData } from "../context/GlobalDataContext";
import { Link } from "react-router-dom";
import "./SyllabusTablePage.css";

const TABLE_PAGE_LIMIT = 29;

function SyllabusTablePage() {
  const { threeTable, fetchThreeTableSection } = useGlobalData();
  const [isUpdating, setIsUpdating] = useState(false);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [localSyllabuses, setLocalSyllabuses] = useState([]);
  // Removed unused initialLoadDone state
  const tableWrapperRef = useRef(null);

  // Initial + paginated load
  const loadSyllabuses = useCallback(async (nextOffset = 0, isInitial = false) => {
    setIsUpdating(true);
    try {
      await fetchThreeTableSection("syllabuses", false, {
        preferLoadedData: false,
        fetchIfPartial: false,
        showLoading: false,
        skipLoader: !isInitial,
        limit: TABLE_PAGE_LIMIT,
        offset: nextOffset
      });
      setHasMore(true);
      setOffset(nextOffset);
      // Removed setInitialLoadDone as it's unused
    } finally {
      setIsUpdating(false);
    }
  }, [fetchThreeTableSection]);

  useEffect(() => {
    if (offset === 0) {
      setLocalSyllabuses(threeTable.syllabuses || []);
      setHasMore((threeTable.syllabuses || []).length === TABLE_PAGE_LIMIT);
      setOffset((threeTable.syllabuses || []).length);
    }
  }, [threeTable.syllabuses, offset]);


  // On mount: agar global state me data hai to wahi use karo, warna API call karo (aur skeleton dikhao)
  useEffect(() => {
    if ((threeTable.syllabuses || []).length > 0) {
      setLocalSyllabuses(threeTable.syllabuses);
      setHasMore(threeTable.syllabuses.length === TABLE_PAGE_LIMIT);
      setOffset(threeTable.syllabuses.length);
      // Removed setInitialLoadDone as it's unused
    } else {
      loadSyllabuses(0, true); // skipLoader: false for skeleton
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!hasMore || isUpdating) return;
      const el = tableWrapperRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      if (rect.bottom <= window.innerHeight + 200) {
        loadSyllabuses(offset, false); // skipLoader: true for scroll
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasMore, isUpdating, offset, loadSyllabuses]);

  const syllabuses = localSyllabuses;

  return (
    <div className="syllabus-table-container">
      <h2>Syllabus Table</h2>
      <div
        className="syllabus-table-wrapper"
        ref={tableWrapperRef}
        style={{ overflowY: "auto", maxHeight: "1400px" }}
      >
        <table className="syllabus-table">
          <thead>
            <tr>
              <th>Job Slug</th>
              <th>View</th>
            </tr>
          </thead>
          <tbody>
            {syllabuses.map((item, i) => (
              <tr key={i}>
                <td>{item.jobSlug}</td>
                <td>
                  <Link to={`/mform/${item.jobSlug}`}>Syllabus View</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Status messages below the table */}
      {isUpdating && syllabuses.length === 0 && (
        <p style={{ marginTop: "10px", textAlign: "center", color: "#1d4ed8", fontWeight: 600 }}>
          Loading syllabuses...
        </p>
      )}
      {isUpdating && syllabuses.length > 0 && (
        <p style={{ marginTop: "10px", textAlign: "center", color: "#1d4ed8", fontWeight: 600 }}>
          Loading more syllabuses...
        </p>
      )}
      {!isUpdating && !hasMore && syllabuses.length > 0 && (
        <p style={{ marginTop: "10px", textAlign: "center", color: "#888" }}>
          No more syllabuses.
        </p>
      )}
    </div>
  );
}

export default SyllabusTablePage;
